var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.531,
    height: 18.994,
    viewBox: "0 0 18.531 18.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bono",
    transform: "translate(-85.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7711",
    "data-name": "Trazado 7711",
    d: "M102.011,18.994H87.187a1.858,1.858,0,0,1-1.853-1.853V7.459a1.868,1.868,0,0,1,.788-1.529L94.6,0l8.478,5.93a1.808,1.808,0,0,1,.788,1.529v9.682a1.859,1.859,0,0,1-1.853,1.853Z",
    fill: "#78909c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7712",
    "data-name": "Trazado 7712",
    d: "M298.667,21.333h9.265V35.694h-9.265Z",
    transform: "translate(-208.701 -20.87)",
    fill: "#aed581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7713",
    "data-name": "Trazado 7713",
    d: "M277.333,0V15.288h10.192V0ZM286.6,14.361h-8.339V.927H286.6V14.361Z",
    transform: "translate(-187.83)",
    fill: "#558b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7714",
    "data-name": "Trazado 7714",
    d: "M307.932,22.26c0,.788-.139,1.39-.927,1.39a1.365,1.365,0,0,1-1.39-1.39c0-.788.6-.927,1.39-.927S307.932,21.472,307.932,22.26Zm-8.339-.927c.788,0,1.39.139,1.39.927a1.365,1.365,0,0,1-1.39,1.39c-.788,0-.927-.6-.927-1.39S298.805,21.333,299.593,21.333Z",
    transform: "translate(-208.7 -20.87)",
    fill: "#558b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7715",
    "data-name": "Trazado 7715",
    d: "M470.26,128.927m-.926,0a.927.927,0,1,0,.926-.927A.926.926,0,0,0,469.333,128.927Z",
    transform: "translate(-375.661 -125.221)",
    fill: "#558b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7716",
    "data-name": "Trazado 7716",
    d: "M386.78,301.447m-2.78,0a2.78,2.78,0,1,0,2.78-2.78A2.78,2.78,0,0,0,384,301.447Z",
    transform: "translate(-292.181 -292.181)",
    fill: "#558b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7717",
    "data-name": "Trazado 7717",
    d: "M102.011,373.785H87.187a1.858,1.858,0,0,1-1.853-1.853v-9.265l9.265,6.022,9.265-6.022v9.265a1.858,1.858,0,0,1-1.853,1.853Z",
    transform: "translate(0 -354.791)",
    fill: "#cfd8dc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.81b8d11d795f4994a481c4f46785cc37.svg";
export { ForwardRef as ReactComponent };